import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import ReCAPTCHA from 'react-google-recaptcha'
import './style.scss'

const SiteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY

class Recaptcha extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      captchaValue: '',
    }
    this.recaptchaRef = React.createRef()
  }

  handleCaptchaValue = () => {
    const captcha = this.recaptchaRef.current.getValue()
    const { handleChange } = this.props
    this.setState({
      captchaValue: captcha,
    })
    handleChange(captcha)
  }

  getCaptchaStateValue = () => {
    const { captchaValue } = this.state
    return captchaValue
  }

  render() {
    return (
      <section className='g-recaptcha-wrapper'>
        <ReCAPTCHA
          className='g-recaptcha'
          ref={this.recaptchaRef}
          sitekey={SiteKey}
          onChange={this.handleCaptchaValue}
        />
      </section>
    )
  }
}

export default Recaptcha

Recaptcha.propTypes = {
  handleChange: PropTypes.func,
}

Recaptcha.defaultProps = {
  handleChange: () => ({}),
}
